import { Recording, type RecordingRow } from './Recording';

interface Props {
    recordings: RecordingRow[];
}

export function Recordings({ recordings }: Props) {
    return (
        <div className='gap-4 md:gap-0 flex flex-col'>
            {recordings.map((x, index) => (
                <Recording
                    recording={x}
                    index={index}
                    key={'isPlaceholder' in x ? 'placeholder' : x.takes[0]!.takeId}
                />
            ))}
        </div>
    );
}
